const CollectionPage = {
    init: async function() {
      if (!document.body.classList.contains('template-collection')) {
        return;
      }
  
      this.updateFreeShippingFilterVisibility();
      this.observeUrlChanges();
      this.observeFilterChanges();
      this.observeAjaxFilterChanges();
    },
  
    updateFreeShippingFilterVisibility: function() {
      const urlParams = new URLSearchParams(window.location.search);
      const hasPriceFilter = urlParams.has('filter.v.price.gte');
      this.updateFilterVisibility('.thb-filter-price-free-shipping-desktop', hasPriceFilter, 'desktop');
      this.updateFilterVisibility('.thb-filter-price-free-shipping-mobile', hasPriceFilter, 'mobile');
    },
  
    updateFilterVisibility: function(selector, hide, type) {
      const filter = document.querySelector(selector);
      if (!filter) {
        console.log(`Filtro ${type} no encontrado`);
        return;
      }
  
      if (hide) {
        filter.style.display = 'none';
        filter.setAttribute('data-hidden', 'true');
      } else {
        console.log(`Mostrando filtro de envío gratis (${type})`);
        filter.style.display = '';
        filter.removeAttribute('data-hidden');
      }
    },
  
    observeUrlChanges: function() {
      let lastUrl = location.href; 
      new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
          lastUrl = url;
          this.updateFreeShippingFilterVisibility();
        }
      }).observe(document, {subtree: true, childList: true});
    },
  
    observeFilterChanges: function() {
      console.log('Configurando observador de cambios en los filtros');
      const filterContainer = document.querySelector('.thb-filter-container');
      if (filterContainer) {
        const observer = new MutationObserver((mutations) => {
          this.updateFreeShippingFilterVisibility();
        });
        observer.observe(filterContainer, { childList: true, subtree: true });
      } else {
        console.log('No se encontró el contenedor de filtros');
      }
    },
  
    observeAjaxFilterChanges: function() {
      document.addEventListener('click', (event) => {
        const clickedFilter = event.target.closest('.thb-filter-price-free-shipping-desktop, .thb-filter-price-free-shipping-mobile');
        
        if (clickedFilter) {
          this.handleFilterClick();
        }
      });
    },
  
    handleFilterClick: function() {
      const checkAndUpdateFilters = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const hasPriceFilter = urlParams.has('filter.v.price.gte');
        
        this.updateFreeShippingFilterVisibility();
  
        if (hasPriceFilter) {
          clearInterval(checkInterval);
        }
      };
  
      // Comprobar inmediatamente
      checkAndUpdateFilters();
  
      // Continuar comprobando cada 100ms durante 2 segundos
      const checkInterval = setInterval(checkAndUpdateFilters, 100);
      setTimeout(() => clearInterval(checkInterval), 2000);
    },
  };
  
  // Inicializar la página de colección cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', function() {
    CollectionPage.init();
  });

  function sleep(ms){
    console.log(`sleep ${ms}`);
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  // Asegurarse de que se actualice la visibilidad después de que la página se haya cargado completamente
  window.addEventListener('load', function() {
    if (document.body.classList.contains('template-collection')) {
      CollectionPage.updateFreeShippingFilterVisibility();
    }
  });
  
  // Añadir un listener para el evento AJAX de Shopify
  document.addEventListener('shopify:section:load', async function(event) {
    if (document.body.classList.contains('template-collection')) {
          
      console.log("price update");
      //Dormimos la ejecución durante 3 segundos
      await sleep(10000);
      CollectionPage.updateFreeShippingFilterVisibility();
    }
  });
  
